var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVeteranIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25.634,
    height: 25.634,
    viewBox: "0 0 25.634 25.634",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a,.d{fill:none;}.a{stroke:#1f3951;stroke-width:1.75px;stroke-dasharray:10 2;}.b{fill:#d12727;}.c{stroke:none;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-27 -7.183)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "a",
    transform: "translate(27 14.023) rotate(-20)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "c",
    cx: 10,
    cy: 10,
    r: 10
  }), /*#__PURE__*/React.createElement("circle", {
    className: "d",
    cx: 10,
    cy: 10,
    r: 9.125
  })), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M9.422,13.1l3.476,2.1-.92-3.956,3.068-2.66L11,8.23,9.422,4.5,7.842,8.23,3.8,8.577l3.068,2.66-.92,3.956Z",
    transform: "translate(30.395 9.797)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVeteranIcon);
export default __webpack_public_path__ + "static/media/veteran-icon.169364f7207080fa9583657e27a8d514.svg";
export { ForwardRef as ReactComponent };